import { makeStyles, colors } from '@material-ui/core'
import palette from 'theme/palette'

const styles = makeStyles((theme) => ({
  avatar: {
    width: 30,
    height: 30,
  },
  chatMessageHuman: {
    padding: theme.spacing(1, 2),
    backgroundColor: colors.lightBlue[50],
    borderRadius: theme.shape.borderRadius,
    marginLeft: theme.spacing(2),
  },
  chatMessageAI: {
    paddingTop: theme.spacing(0.5),
    flexGrow: 1,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    '& h1': {
      fontSize: '1.6rem',
    },
    '& ul, & ol': {
      paddingLeft: theme.spacing(2.5),
    },
    '& table': {
      borderCollapse: 'collapse',
      width: '100%',
    },
    '& th, & td': {
      padding: theme.spacing(1),
      border: '1px solid #ddd',
    },
    '& img, & pre, & code': {
      maxWidth: '100%',
      boxSizing: 'border-box',
      overflow: 'auto',
    },
    '& > *': {
      marginBottom: theme.spacing(1),
    },
    '& > *:last-child': {
      marginBottom: 0,
    },
  },
  chatMessageText: {
    color: 'black',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  },
  chatMessageHumanText: {
    whiteSpace: 'pre-wrap',
  },
  daiIcon: {
    fill: 'currentColor',
    color: palette.dai.shinyBlue,
    width: '24px',
    height: '24px',
    display: 'block',
  },
}))

export default styles
